import { useEffect, useState } from 'react';
import PostingsApi from '../../../../../API/shipment/postings-api';
import RealizationApi from '../../../../../API/shipment/realization-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Select } from '../../../../../components/Basic/Inputs';
import { H2, Text } from '../../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_NAME, TYPE_BUTTONS } from '../../../../../constans';
import { getDate } from '../../../../../utils';
import styles from './styles.module.scss';

const AddToRealizationPopUp = ({ close = () => { }, market = '', shop = '', date = undefined, postings = [], num = '' }) => {
  console.log(postings);
  const [selectRealization, setSelectRealization] = useState(null);
  console.log('1', shop, MAP_SKLAD_NAME[shop]);
  const [realizations, setRealizations] = useState([]);

  const clickAdd = async () => {
    await PostingsApi.changePostings({ data: { postingNumbers: postings, field: 'realization_id', value: selectRealization.id } });
    close();
  };

  useEffect(() => {
    RealizationApi.getRealizations({ data: { status: '', market, limit: 10, dateRealization: date } }).then((r) => setRealizations(r.realizations));
  }, []);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить в реализацию</H2>

      <Select
        list={realizations}
        select={selectRealization}
        label={'Реализация'}
        valueFn={(item) => (item ? `${item.market} ${getDate(item.date_realization)}` : null)}
        onSelect={(v) => setSelectRealization(v)}
      />

      <Text fontSize={15} style={{ marginTop: '10px' }}>{`Количество заказов ${num}`}</Text>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          onClick={clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default AddToRealizationPopUp;
